import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.q5j().u54() : headers;
  return DelegatedCall().m5l(_this__u8e3s4.l5j_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.m5l(client, originCall, responseContent, responseHeaders);
      }
      static m5l(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.q5j().u54() : responseHeaders;
        var $this = this.n5l(client);
        $this.n5j_1 = new (DelegatedRequest())($this, originCall.o5l());
        $this.o5j_1 = new (DelegatedResponse())($this, originCall.q5j(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.t5l_1 = origin;
        this.u5l_1 = call;
      }
      v5l() {
        return this.u5l_1;
      }
      ww() {
        return this.t5l_1.ww();
      }
      w5l() {
        return this.t5l_1.w5l();
      }
      x5l() {
        return this.t5l_1.x5l();
      }
      p5l() {
        return this.t5l_1.p5l();
      }
      p2q() {
        return this.t5l_1.p2q();
      }
      u54() {
        return this.t5l_1.u54();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.u54() : headers;
        super();
        this.y5l_1 = call;
        this.z5l_1 = origin;
        this.a5m_1 = content;
        this.b5m_1 = headers;
        this.c5m_1 = this.z5l_1.ww();
      }
      v5l() {
        return this.y5l_1;
      }
      u54() {
        return this.b5m_1;
      }
      d5m() {
        return this.a5m_1(this.z5l_1);
      }
      ww() {
        return this.c5m_1;
      }
      e5m() {
        return this.z5l_1.e5m();
      }
      f5m() {
        return this.z5l_1.f5m();
      }
      g5m() {
        return this.z5l_1.g5m();
      }
      h5m() {
        return this.z5l_1.h5m();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
